import {
    TableDataCell,
    TableDataRow,
    VesselNameWrapper,
    TooltipButton,
    TooltipIcon,
    TooltipContent,
    TooltipList,
    TooltipListItem,
} from './_styled/table-row.styled'
import {CustomerReports} from '../../../../values/customer-reports'
import {ReportsAttachmentsTable} from './report-attachments-table/reports-attachments-table'
import {formatDateWithoutTime} from '../../../../helpers/formatting'
import useTypedSelector from '../../../../hooks/use-typed-selector'
import {locationMapSelector} from '../../../../store/state/locations/selectors'
import {basalGangliaEnvMapSelector} from '../../../../store/state/basal-ganglia-env/selectors'
import {getBasalGangliaEnvDescription, getVesselDescriptionWithTooltip} from '../data-helpers'
import QUESTION_MARK_ICON_SVG from '../../../../@assets/icons/question-circle.svg'
import Tippy from '@tippyjs/react'
import 'tippy.js/dist/tippy.css'

interface TableRowProps {
    report: CustomerReports
    index: number
}

export function TableRow({report, index}: TableRowProps): JSX.Element {
    const locationMap = useTypedSelector(locationMapSelector)
    const shipManagerMap = useTypedSelector(basalGangliaEnvMapSelector)

    const {description, vesselNames} = getVesselDescriptionWithTooltip(
        locationMap,
        report.locations,
    )
    const tooltipList = vesselNames?.flat().filter((x): x is string => Boolean(x))

    const tooltipContent = tooltipList ? (
        <TooltipContent>
            <TooltipList>
                {tooltipList.map((name) => (
                    <TooltipListItem key={name}>{name}</TooltipListItem>
                ))}
            </TooltipList>
        </TooltipContent>
    ) : null

    const gridRow = index + 1

    return (
        <>
            <TableDataRow gridRow={gridRow} id={`data-row_${report.identity}`} />

            <TableDataCell
                gridRow={gridRow}
                gridColumn={2}
                id={`reports-vessel_${report.identity}`}
            >
                {tooltipList && tooltipList.length > 0 ? (
                    <VesselNameWrapper>
                        <span>{description}</span>
                        <Tippy content={tooltipContent} interactive placement="right">
                            <TooltipButton type="button" aria-label="Show vessel names">
                                <TooltipIcon
                                    src={QUESTION_MARK_ICON_SVG}
                                    alt=""
                                    width={14}
                                    height={14}
                                />
                            </TooltipButton>
                        </Tippy>
                    </VesselNameWrapper>
                ) : (
                    <span>{description}</span>
                )}
            </TableDataCell>

            <TableDataCell
                gridRow={gridRow}
                gridColumn={3}
                id={`reports-ship-manager_${report.identity}`}
            >
                {getBasalGangliaEnvDescription(
                    shipManagerMap,
                    report.basalGangliaEnvironmentIdentity,
                )}
            </TableDataCell>

            <TableDataCell
                gridRow={gridRow}
                gridColumn={4}
                id={`reports-report-type_${report.identity}`}
            >
                {report.reportType}
            </TableDataCell>

            <TableDataCell
                gridRow={gridRow}
                gridColumn={6}
                id={`reports-report-id_${report.identity}`}
            >
                {report.reportCode}
            </TableDataCell>

            <TableDataCell
                gridRow={gridRow}
                gridColumn={7}
                id={`reports-start-date_${report.identity}`}
            >
                {formatDateWithoutTime(report.periodStartDate)}
            </TableDataCell>

            <TableDataCell
                gridRow={gridRow}
                gridColumn={8}
                id={`reports-end-date_${report.identity}`}
            >
                {formatDateWithoutTime(report.periodEndDate)}
            </TableDataCell>

            <ReportsAttachmentsTable report={report} gridRow={gridRow} />
        </>
    )
}
